import { api } from 'api';

import { ExportShiftNotesCsvParams } from 'types/residentShiftNotes';

import { useErrorHandledQuery } from 'hooks/useErrorHandledQuery';
import { formatApiParams, useToken } from 'lib/common';

export const useExportShiftNotesCsvQuery = (jsonParams: ExportShiftNotesCsvParams) => {
    const token = useToken();
    return useErrorHandledQuery(
        ['export-shift-notes-csv', jsonParams],
        async () => {
            const { data } = await api.get<ArrayBuffer>(`/resident-shift-notes/export-csv`, {
                headers: { Authorization: token },
                params: formatApiParams(jsonParams),
                responseType: 'blob',
            });
            return data;
        },
        { enabled: false }
    );
};
